import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-icon_jax_f776da5d859e10eee56d87ff5a7e2ff2",
  "use": "check-icon_jax_f776da5d859e10eee56d87ff5a7e2ff2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check-icon_jax_f776da5d859e10eee56d87ff5a7e2ff2\">\n<path d=\"M22 4L8.36957 20L3 15.4783\" stroke=\"#2CD4AE\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol